/* globals Swiper */
import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import { sliderPagination } from '~/js/helpers';

const cards = [...document.querySelectorAll('.cards')];

cards.forEach((card) => {
	const cardSlider = card.querySelector('.swiper-cards');
	if (!cardSlider) return;

	const slidesPerView = Number(cardSlider.dataset.swiperColumns) || 4;

	// Determine the default gap value from CSS variables or fallback to a default value
	var style = window.getComputedStyle(document.body);
	let defaultGap = style.getPropertyValue('--gap-auto');
	if (defaultGap && defaultGap.includes('rem')) {
		const remValue = parseFloat(defaultGap);
		const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
		defaultGap = `${remValue * rootFontSize}px`;
	}
	if (!defaultGap || defaultGap.trim() === '') {
		defaultGap = '32px';
	}

	const navigation = cardSlider.querySelector('.swiper-navigation');

	new Swiper(cardSlider, {
		modules: [Navigation, Pagination, A11y, Mousewheel],
		a11y: true,
		grabCursor: true,
		loop: false,
		slidesPerView: 1.05,
		spaceBetween: defaultGap,
		keyboard: {
			enabled: true,
		},
		navigation: {
			nextEl: cardSlider.querySelector('.swiper-button-next'),
			prevEl: cardSlider.querySelector('.swiper-button-prev'),
		},
		pagination: sliderPagination(cardSlider.querySelector('.swiper-pagination')),
		breakpoints: {
			760: { slidesPerView, spaceBetween: 32 },
			1024: { slidesPerView },
		},
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		on: {
			lock: () => {
				if (navigation) {
					navigation.style.display = 'none';
				}
			},
			unlock: () => {
				if (navigation) {
					navigation.style.display = 'flex';
				}
			},
		},
	});
});
